import { render } from "./ConcordanceSearchResultItem.vue?vue&type=template&id=51ea12ba&scoped=true&ts=true"
import script from "./ConcordanceSearchResultItem.vue?vue&type=script&lang=ts"
export * from "./ConcordanceSearchResultItem.vue?vue&type=script&lang=ts"

import "./ConcordanceSearchResultItem.vue?vue&type=style&index=0&id=51ea12ba&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51ea12ba"]])

export default __exports__